<template>
  <div v-if="currentLanguage" class="language">
    <!-- desktop -->
    <div class="dropdown d-none d-sm-inline-block" v-if="campaign && !campaign.header_content">
      <span class="selected-language">
        <img width="" height="" :src="require('@/assets/images/languages/' + currentLanguage + '.png')" alt="">
      </span>
      <button class="language-button footer_btn_color"><span class="d-none d-md-inline-block">Select&nbsp;</span>Language</button>
      <div class="dropdown-content">
        <b-link v-for="language in languages" :key="'language-' + language.code" @click="selectLanguage(language.code)" v-lazy-container="{ selector: 'img' }">
          <img width="" height="" :data-src="require('@/assets/images/languages/' + language.code + '.png')" alt="">
          <span class="notranslate">{{language.label}}</span>
          <font-awesome-icon :icon="['fas', 'check']" class="lang-check" v-if="currentLanguage === language.code"></font-awesome-icon>
        </b-link>
      </div>
    </div>
    <!-- mobile -->
    <div class="dropdown d-sm-none" v-if="campaign && !campaign.header_content">
      <button  class="language-button footer_btn_color" v-b-modal.mob-lang-modal>
        <span class="selected-language"><img width="" height="" :data-src="require('@/assets/images/languages/' + currentLanguage + '.png')" alt=""></span>
        <span class="notranslate language-label">{{shortCode}} <font-awesome-icon :icon="['fas', 'caret-down']"></font-awesome-icon></span>
      </button>
    </div>
    <b-modal id="mob-lang-modal" title="Select Language" hide-footer>
      <div class="dropdown-content mob-languages" v-lazy-container="{ selector: 'img' }">
        <b-link v-for="language in languages" :key="'language-' + language.code" @click="selectLanguage(language.code)">
          <div class="language-option">
            <div :class="{'mob-lang-active': currentLanguage === language.code}">
              <img width="" height="" :data-src="require('@/assets/images/languages/' + language.code + '.png')" alt="" class="mob-lang-img">
              <span class="notranslate">{{language.label}}</span>
              <font-awesome-icon :icon="['fas', 'check']" class="lang-check"></font-awesome-icon>
            </div>
          </div>
        </b-link>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getDomain } from '../utils'

export default {
  name: 'Language',
  data: function() {
    return {
      languages: [
        {code: 'en', label: 'English'},
        {code: 'es', label: 'Español'},
        {code: 'fr', label: 'Français'},
        {code: 'de', label: 'Deutsche'},
        {code: 'pt', label: 'Português'},
        {code: 'ru', label: 'Pусский'},
        {code: 'zh-CN', label: '中文'},
        {code: 'ko', label: '한국어'},
        {code: 'ja', label: '日本語'},
        {code: 'hi', label: 'हिंदी'}
      ]
    }
  },
  computed: {
    ...mapState(['currentLanguage', 'campaign']),
    selectedLanguageLabel: function() {
      for (const language of this.languages) {
        if (language.code === this.currentLanguage) {
          return language.label
        }
      }

      return ''
    },
    shortCode: function() {
      return this.currentLanguage.substr(0, 2).toUpperCase()
    }
  },
  methods: {
    selectLanguage: function(code) {
      if (code !== this.currentLanguage) {
        // set the new translation
        this.$cookie.delete('googtrans', {domain: window.location.hostname})
        this.$cookie.delete('googtrans', {domain: getDomain()})
        this.$cookie.set('googtrans', '/en/' + code)
        this.$store.commit('set_language', code)
        this.$store.dispatch('update_session', {language: code})
          .then(result => {
            this.$router.go(0) // refresh
          })
      }
    }
  },
  created() {
    // get the current language translation
    const lang = this.$cookie.get('googtrans')

    if (lang && lang.length) {
      if (lang[0] === '/') {
        const languages = lang.substr(1).split('/')

        if (languages.length === 2) {
          this.$store.commit('set_language', languages[1])
        }
      }
    }
  }
}
</script>

<style scoped lang="less">

</style>
